export function readOnlyFieldValue(
  value: string | undefined | null,
  readOnly: boolean,
  options?: { optional?: boolean },
): string {
  if (!readOnly) {
    return value ?? "";
  }

  const trimmed = (value ?? "").trim();

  if (options?.optional && trimmed === "") {
    return "Not Provided";
  }

  return trimmed;
}